import crypto from 'crypto-browserify';
const Buffer = require('buffer/').Buffer;

const _devPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAs74d+NUF3lWqTNxEzrA6
KVXfRMo9QZp7/K1kwFQtQfM3UMO7IeyZMzpPYIVHvziQVWXXVDhH61813XqnJxe/
bqwqSaj4+/8MUF80RyNWu6YdBMy95ha9GMbddLyvIMDyXsHvy4cUldr0+f8Q2hea
hL0Grq7JjX54TVA3n75/7iLh+8w67d47ARmYgOLTkyyD7AWykob+HeDbZsaa0z0C
LfMcRBGFNwg7S3inS+Ri4hjiy6zmhfRlU8WM350T45hZPr5cKqHMHuB1xTqOWg8t
6LR8DkvA32mSDhHiWAfLGU1XbZOOZx/oj/Hqtz89CLDleaA5qx2AR/+TfoR8iNZm
wwIDAQAB
-----END PUBLIC KEY-----
`;

const _prodPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlqwoMbF4RxJKe0YpB8UA
RbRZsej6g5GhdsZTyIjrG7SX38tzUlgHdssIeia3U9X+AriDByn/zjNxsJeipbNC
G7Ut/fWr1QYswPSO2v4TXBi1JV101cE/PFj54PY+M4fGzmaX5MIN0P4JwjpDXP2f
kT/thXp+OYoqmveVVADMpWUBZXNkBxllWjc8PjXrLdNq3PUMHiOocXN2XApszJ47
7jKYIlKZza8Wd1ciBGgkrpyjADtcXiKIUpnF4HPIH+JCmQDrpUc1Jm7N0gb2OR6X
BUOi5cNQf/MHkqrJGcOHC4LWtJ9SmQ5b026E20J+AhTs+YDp8lzImgfZ8kK94/fT
EQIDAQAB
-----END PUBLIC KEY-----
`;

const _publicKeys = {
	local: _devPublicKey,
	development: _devPublicKey,
	production: _prodPublicKey
};

export function encryptCheckout(cardInformation) {
	const publicKey = _publicKeys[process.env.REACT_APP_ENV];

	const buffer = Buffer.from(JSON.stringify(cardInformation));

	const encryptedBuffer = crypto
		.publicEncrypt(
			{
				key: publicKey
			},
			buffer
		)
		.toString('base64');

	return encryptedBuffer;
}
